import { createRouter, createWebHistory } from 'vue-router'
import { useMainStore } from '@/store'
import static_vars from '@/staticVars'


import Index from '@/views/index.vue'

// import Login from '@/views/users/login'
import register from '@/views/users/register'
import forgot_password from '@/views/users/forgot_password'
import create_password from '@/views/users/create_password'
import get_otp from '@/views/users/get_otp'
import personal_details from '@/views/personal-details/personal_details'
import complete_registration from '@/views/personal-details/complete-registration'
import trading_account from '@/views/personal-details/trading_account'
import add_trading_account from '@/views/personal-details/add_trading_account'
import broker_account from '@/views/personal-details/link-broker/broker_account'
import select_a_broker from '@/views/personal-details/select_a_broker'
import connected_succesfully from '@/views/personal-details/connected_succesfully'
import Image from '@/views/personal-details/upload-image'
import CreateDemoAccount from '@/views/personal-details/create-demo-account'

import add_broker from '@/views/personal-details/add-broker'
import link_broker_success from '@/views/personal-details/link-broker/link-broker-suucess'
import become_leader from '@/views/personal-details/link-broker/become-leader'


import create_broker_account from '@/views/personal-details/intergrate-broker/personalinfo-A'
import create_broker_account2 from '@/views/personal-details/intergrate-broker/personalinfo-B'
import create_broker_account3 from '@/views/personal-details/intergrate-broker/financial-details'
import create_broker_account4 from '@/views/personal-details/intergrate-broker/questionaries'
import create_broker_account5 from '@/views/personal-details/intergrate-broker/declaration'
import create_broker_account6 from '@/views/personal-details/intergrate-broker/mannual-por'
import create_broker_account7 from '@/views/personal-details/intergrate-broker/sumsub'
import account_prefrences from '@/views/personal-details/intergrate-broker/account-prefrences'
import add_funds from '@/views/personal-details/intergrate-broker/add-funds'
import create_broker_account8 from '@/views/personal-details/intergrate-broker/suitability'


import crypto_exhange_account from '@/views/personal-details/crypto_exhange_account'
import crypto_exhange_account1 from '@/views/personal-details/crypto_exhange_account1'
import crypto_exhange_account2 from '@/views/personal-details/crypto_exhange_account2'
import crypto_exhange_account3 from '@/views/personal-details/crypto_exhange_account3'
// import subscription_plan from '@/views/subscription/subscription-plan'
import connect_account from '@/views/account/connect_account'
import demo_account from '@/views/account/demo_account'
import Dashboard from '@/views/home/dashboard'

// import success from '@/views/subscription/redirect/success'
// import failure from '@/views/subscription/redirect/failure'
// import redirect from '@/views/subscription/redirect/redirect'

import test_result from '@/views/personal-details/intergrate-broker/test-result'
import seoData from '../../public/assets/js/seo.js'
import {nextTick} from 'vue';

//Tools
// const Tools = () => import('@/views/tools/index.vue')

//Others
const routes = [
  { path: '/:pathMatch(.*)*', component: Dashboard },
  {
    path: '/', name: 'Register', component: register, meta: { requiresAuth: false },
  },
  // {
  //   path: '/register', name: 'Register', component: register, meta: { requiresAuth: false },
  // },
  {
    path: '/forgot-password', name: 'Forgot_Password', component: forgot_password, meta: { requiresAuth: false },
  },
  {
    path: '/reset-password/:hash', name: 'Reset_Password', component: create_password, meta: { requiresAuth: false },
  },
  // {
  //   path: "/payment/redirect", name: "redirect", component: redirect, meta: { requiresAuth: false },
  // },
  {
    path: '/',  component: Index, meta: { requiresAuth: true }, children: [
      // { path: '/dashboard', component: Dashboard, name: 'Dashboard', meta: { requiresAuth: false } },
      { 
        path: '/get-otp', name: 'Get_OTP', component: get_otp, meta: { requiresAuth: false },
      },
      {
        path: '/personal-details', name: 'personal_details', component: personal_details, meta: { requiresAuth: true },
      },
      {
        path: '/complete-registration', name: 'complete_registration', component: complete_registration, meta: { requiresAuth: true },
      },
      {
        path: '/upload-image', name: 'Image', component: Image, meta: { requiresAuth: true },
      },
      {
        path: '/demo-acc', name: 'demo_acc', component: CreateDemoAccount, meta: { requiresAuth: true },
      },
      {
        path: '/trading-account', name: 'trading_account', component: trading_account, meta: { requiresAuth: true },
      },
      {
        path: '/add-trading-account', name: 'add_trading_account', component: add_trading_account, meta: { requiresAuth: true },
      },
      {
        path: '/broker-account', name: 'broker_account', component: broker_account, meta: { requiresAuth: true },
      },
      {
        path: '/select-a-broker', name: 'select_a_broker', component: select_a_broker, meta: { requiresAuth: true },
      },
      {
        path: '/connected-succesfully', name: 'connected_succesfully', component: connected_succesfully, meta: { requiresAuth: true },
      },
      {
        path: '/add-broker', name: 'add_broker', component: add_broker, meta: { requiresAuth: true },
      },
      {
        path: '/personalInfo-step1/:id', name : 'create_broker_account' ,component: create_broker_account, meta: { requiresAuth: true },
      },
      {
        path: '/personalInfo-step2/:id', name : 'create_broker_account2', component: create_broker_account2, meta: { requiresAuth: true },
      },
      {
        path: '/financial-detials/:id', name : 'create_broker_account3', component: create_broker_account3, meta: { requiresAuth: true },
      },
      {
        path: '/questionnaires/:id', name : 'create_broker_account4', component: create_broker_account4, meta: { requiresAuth: true },
      },
      {
        path: '/declaration/:id', name : 'create_broker_account5', component: create_broker_account5, meta: { requiresAuth: true },
      },
      {
        path: '/upload-por/:id', name : 'create_broker_account6', component: create_broker_account6, meta: { requiresAuth: true },
      },
      {
        path: '/sumsub/:id', name : 'create_broker_account7', component: create_broker_account7, meta: { requiresAuth: true },
      },
      {
        path: '/sutaibility', name : 'create_broker_account8', component: create_broker_account8, meta: { requiresAuth: true },
      },
       {
        path: '/account-preferences/:id', name : 'account_prefrences', component: account_prefrences, meta: { requiresAuth: true },
      },
      {
        path: '/add-funds/:id', name : 'add_funds', component: add_funds, meta: { requiresAuth: true },
      },
      {
        path: '/crypto-exhange-account', name : 'crypto_exhange_account', component: crypto_exhange_account, meta: { requiresAuth: true },
      },
      {
        path: '/crypto-exhange-account1', name : 'crypto_exhange_account1', component: crypto_exhange_account1, meta: { requiresAuth: true },
      },
      {
        path: '/crypto-exhange-account2', name : 'crypto_exhange_account2', component: crypto_exhange_account2, meta: { requiresAuth: true },
      },
      {
        path: '/crypto-exhange-account3', name : 'crypto_exhange_account3', component: crypto_exhange_account3, meta: { requiresAuth: true },
      },
      // {
      //   path: '/subscription-plan', name : 'subscription_plan', component: subscription_plan, meta: { requiresAuth: true },
      // },
      {
        path: '/connect-account', name : 'connect_account', component: connect_account, meta: { requiresAuth: true },
      },
       {
        path: '/demo-account', name : 'demo_account', component: demo_account, meta: { requiresAuth: true },
      },
      // {
      //   path: '/payment/success', name : 'success', component: success, meta: { requiresAuth: true },
      // },
      //  {
      //   path: '/payment/failure', name : 'failure', component: failure, meta: { requiresAuth: true },
      // },
       {
        path: '/link-broker-success', name : 'link_broker_success', component: link_broker_success, meta: { requiresAuth: true },
      },
      {
        path: '/become-leader', name : 'become_leader', component: become_leader, meta: { requiresAuth: true },
      },
      {
        path: '/test-result', name : 'test_result', component: test_result, meta: { requiresAuth: true },
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: '/register/',
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
  }
})

router.beforeEach((to) => {
  const badge = document.getElementsByClassName('grecaptcha-badge');
    if (badge.length) {
        badge[0].style.visibility = (to.name == 'Register' || to.name == 'Get_OTP' || to.name == 'personal_details') ? 'visible' : 'hidden';
    }
  const store = useMainStore();
  // console.log("store.user.access_token && !store.customerDetail.emailVerified && to.path != 'get-otp'",to.meta.requiresAuth && store.user.access_token && !store.customerDetail.emailVerified && to.path != 'get-otp' )

  

  //when we hit path with token
    // if(to.query.token){
    //   if(store.user.access_token){
    //       let data = store.user
    //       data.access_token = to.query.token
    //       store.$patch({'user' : {'access_token' : to.query.token}})
    //   }else{
    //       store.$patch({'user' : {'access_token' : to.query.token}})
    //   }
    //   if (localStorage.getItem("zulutoken") !== null) {
    //     let json = {};
    //     json['access_token'] = to.query.token
    //       localStorage.setItem('zulutoken', to.query.token);
    //       store.$patch({'user' : json})
    //   }else{
    //     localStorage.setItem('zulutoken', to.query.token);
    //   }
    //   router.replace(to.path)
    // }
    // if (to.meta.requiresAuth && !store.user.token) return { name: 'Login' }
    // if (!to.meta.requiresAuth && store.user.token) return { name: 'Dashboard' }

    if (localStorage.getItem("zulutoken") !== null) {
        let json = {};
        json['access_token'] = localStorage.getItem("zulutoken")
        if (localStorage.getItem("zulurefreshToken") !== null) {
          json['refresh_token'] = localStorage.getItem("zulurefreshToken")
        }
        store.$patch({'user' : json})
    }else{
        if(store.user.access_token){
          localStorage.setItem('zulutoken', store.user.access_token);
          if(store.user.refresh_token){
              localStorage.setItem('zulurefreshToken', store.user.refresh_token);
          }
        }
    }


    /* Login after Landing pages */
    if(to.query.token){
      store.$reset()
      if(to.query.refresh_token){
          store.$patch({'user' : {'access_token' : to.query.token,'refresh_token' : to.query.refresh_token}})
      }else{
          store.$patch({'user' : {'access_token' : to.query.token}})
      }
      if (localStorage.getItem("zulutoken") !== null) {
          localStorage.removeItem("zulutoken");
          if (localStorage.getItem("zulurefreshToken") !== null) {
              localStorage.removeItem("zulurefreshToken");
          }
          let json = {};
          json['access_token'] = to.query.token
          if(to.query.refresh_token){ json["refresh_token"] = to.query.refresh_token; }
          localStorage.setItem('zulutoken', to.query.token);
          if(to.query.refresh_token){ localStorage.setItem('zulurefreshToken', to.query.refresh_token); }
          store.$patch({'user' : json})
      }else{
        localStorage.setItem('zulutoken', to.query.token);
        if(to.query.refresh_token){ localStorage.setItem('zulurefreshToken', to.query.refresh_token); }
      }



   
      //end here


      // let path = `${static_vars.domainURL}register/${to.path}`;
      // if(Object.keys(to.query).length){
      //   let qs = new URLSearchParams(to.query);
      //   path += `?${qs.toString()}`;
      // }
      // router.push({'query' : {}})
    } 

    
  /* Redirect to login if not logged-in  */
  if ((localStorage.getItem("zulutoken") === null && !store.user.access_token) && ((to.name != "Register") && (to.name != "Forgot_Password") && (to.name != "Reset_Password"))){
    window.open(`${static_vars.domainURL}login`,'_self')
    // console.log(`${static_vars.domainURL}login`)
  }

   /* Redirect to dashboard if logged-in  */
  if ((store.user.access_token && localStorage.getItem("zulutoken") !== null) && ((to.name == "Register"))){
  window.open(`${static_vars.domainURL}dashboard`,'_self')
  }
  if (to.path == "/subscription-plan" || to.path == "/payment/redirect" || to.path == "/payment/success" || to.path == "/payment/failure"){
    window.open(`${static_vars.domainURL}leaders`,'_self')
  }
  
})

// Meta and Canonical tag's
router.afterEach((to) => {
  nextTick(() => {
      let seoJson = {}
      seoJson = seoData[0]
      let key = to.path.split('/');
      key = key.filter(i => i).join('/')
      let getSeoPath = seoJson[key]
      // console.log(getSeoPath)
      if(getSeoPath){
          document.title = getSeoPath.META_TITLE;
          document.querySelector('meta[name="description"]').setAttribute("content", getSeoPath.META_DESCRIPTION);
      } 
      // Canonical Tag
      const existingLink = document.querySelector('link[rel="canonical"]');
      if (existingLink) { existingLink.remove() }
      const fullUrl = document.location.href.split('#')[0];
      const currentUrl = fullUrl.split('?')[0];
      if (currentUrl) {
        const link = document.createElement('link');
        link.rel = 'canonical';
        link.href = currentUrl;
        document.head.appendChild(link);
      }
      // hreflang annotations for all language variations
      document.querySelectorAll('link[rel="alternate"]').forEach(link => link.remove());
      const lang = ['en','x-default']
      lang.map(k=>{
          const link = document.createElement('link');
          link.rel = 'alternate',
          link.hreflang = k,
          link.href = currentUrl
          document.head.appendChild(link);
      })
  });
});

export default router
